import getDensityOptionState from '../store/store';
import { discardDensityOption } from '../actions/internalActions';
import { mutator } from 'satcheljs';

mutator(discardDensityOption, () => {
    getDensityOptionState().densityModeSelected = null;
});
